
export const decodeStringParameter = <T>(value: undefined | string, fallback: T): T | string => {
  return typeof value === 'undefined' ? fallback : value;
};
